<template>
  <j-modal
    :title="title"
    width="45%"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :body-style="{ height: '480px', overflow: 'hidden', overflowY: 'scroll' }"
    :okButtonProps="{ class: { 'jee-hidden': true } }"
    @cancel="handleCancel"
    :cancelText="$t('关闭')"
  >
    <a-spin :spinning="confirmLoading">
      <a-row :gutter="24">
        <a-col :span="24">
          <div id="chart" style="width: 100%; height: 400px"></div>
        </a-col>
      </a-row>
    </a-spin>
  </j-modal>
</template>
        
<script>
import { httpAction, getAction, postAction } from '@/api/manage'
import * as echarts from 'echarts';
export default {
  name: 'FaultRateChartModal',
  components: {},
  data() {
    return {
      width: 800,
      visible: false,
      disableSubmit: false,
      model: {},
      confirmLoading: false,
      validatorRules: {},
      url: {
        getCount: '/jeecg-charge/meterInspectionRecord/getCount',
      },
    }
  },
  computed: {
    // i18n：modal 标题
    title() {
      return this.$t('故障率趋势图')
    },
  },
  methods: {
    add() {
      this.edit({})
    },
    edit(record) {
      this.model = Object.assign({}, record)
      this.visible = true
      this.$nextTick(() => {
        this.setChart()
      })
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleOk() {},
    handleCancel() {
      this.close()
    },
    setChart() {
      let chart = echarts.init(document.getElementById('chart'))
      chart.setOption({
        title: {
          text: this.$t('故障率趋势图'),
        },
        tooltip: {
          trigger: 'axis',
        },
        visualMap: {
          min: 0,
          max: 100,
          show: false,
          type: 'continuous',
          seriesIndex: 0,
        //   dimension: 0,
        //   inRange: {
        //     color: ['#F0F4F8', '#3BA1FF'],
        //   },
        },
        xAxis: {
          data: ['2023-01-01', '2023-01-02', '2023-01-03', '2023-01-04', '2023-01-05'],
        },
        yAxis: {},
        series: [
          {
            data: [10, 20, 30, 25, 18],
            type: 'line',
          },
        ],
      })
      window.addEventListener('resize', function () {
        chart.resize()
      })
    },
  },
}
</script>
      <style scoped>
.table-fixed /deep/ .ant-table-bordered .ant-table-fixed-left table {
  border-right: 1px solid #e8e8e8;
}

.table-fixed /deep/ .resize-table-th {
  position: relative;
}
.table-fixed /deep/ .table-draggable-handle {
  border: 1px solid red;
  height: 100% !important;
  left: auto !important;
  right: -5px;
  cursor: col-resize;
  touch-action: none;
  border: none;
  position: absolute;
  transform: none !important;
  bottom: 0;
}
</style>